<script setup>
  import { ref, onMounted, watch, watchEffect} from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useUserStore } from '@/stores/UserStore'
  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';
  import { useToaster } from '@/composables/useToaster';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();
  const toaster = useToaster();

  const { t } = useI18n();

  const profileName = ref(``);
  const showModal = ref(false);

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function createProfile() {
    if (!profileName.value) {
      toaster.toast({
        type: 'warning',
        content: t('profiles.nameRequired'),
      })

      return;
    }

    await userStore.addProfile(profileName.value);
    await userStore.getProfiles(true);

    toaster.toast({
      type: 'success',
      content: t('profiles.createdToast', { name: profileName.value }),
    })

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  })

  watch(() => props.profileId, () => {
    profileName.value = userStore.getProfileById(props.profileId).name;
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="true"
  >
    <ModalContentTextInput
      v-model="profileName"
      :modalTitle="t('profiles.createNewProfile')"
      labelText="Name"
      acceptButtonText="Save"
      :required="true"
      @accept="createProfile"
      @cancel="closeModal"
    /> 
  </BaseModal>
</template>